import { combineEpics, ofType, StateObservable } from 'redux-observable'
import { filter, fromEvent, map, Observable, switchMapTo, take, withLatestFrom } from 'rxjs'
import { io } from 'socket.io-client'

import { RootState } from '.'

console.log('socket')

const connection = io('wss://gastrosoft.ru', {
  path: '/api/pusher',
  transports: ['websocket', 'polling'],
  autoConnect: false,
})

const socketAction$: Observable<any> = fromEvent(connection, 'action')

const socketRegisterEpic$ = (action$: Observable<any>, state$: StateObservable<RootState>) => {
  return socketAction$.pipe(
    filter(({ type }) => type === 'SOCKET/CONNECTED'),
    switchMapTo(
      state$.pipe(
        take(1),
        map((state) => {
          const outletId = state.auth.user?.outlet

          if (outletId) connection.emit('setUser', outletId)

          return false
        }),
        filter(() => false),
      ),
    ),
  )
}

/*
 * Подключение: и после входа, и после восстановления сессии.
 *
 * ⚠️ ВТОРОЕ ЗДЕСЬ ГЛАВНОЕ. Раньше эпик слушал только `auth/loginSuccess`,
 * а шлёт его единственное место — форма входа. При перезагрузке страницы
 * с сохранённым токеном путь другой: стор поднимается сразу в `checking`,
 * дальше getMe → `auth/userLoadSuccess` → `loggedIn`, и `loginSuccess` не
 * приходит никогда. То есть **после любого F5 корнер оставался без живых
 * обновлений до следующего входа**, и ничем это не показывалось: экран
 * выглядел рабочим, просто новые заказы переставали появляться сами.
 *
 * ⚠️ Токен кладётся в `connection.auth` ПЕРЕД `connect()`, а не в
 * настройки при создании: соединение создаётся на уровне модуля, когда
 * токена ещё нет. `socket.io-client` читает `auth` в момент подключения,
 * поэтому так и надо.
 *
 * Зачем токен: гейтвей (задача `s-3`) опознаёт клиента и считает, сколько
 * подключений пришло без токена. Пока это число не ноль, включить жёсткую
 * проверку доступа нельзя — сегодня любой, кто открыл сокет, подписывается
 * на чужую точку.
 *
 * Пустой токен уезжает как `{}`, а не `{token: null}`: второе гейтвей
 * прочитал бы как присланный негодный токен и посчитал бы в `invalidToken`,
 * то есть испортил бы ровно тот счётчик, ради которого всё делается.
 */
const socketConnectEpic = (action$: Observable<any>, state$: StateObservable<RootState>) => {
  return action$.pipe(
    ofType('auth/loginSuccess', 'auth/userLoadSuccess'),
    withLatestFrom(state$),
    map(([, state]) => {
      if (connection.connected) return false

      const token = state.auth?.accessToken
      connection.auth = token ? { token } : {}
      connection.connect()
      return false
    }),
    filter(() => false),
  )
}

const socketDisconnectEpic = (action$: Observable<any>) => {
  return action$.pipe(
    ofType('auth/reset'),
    map(() => {
      connection.disconnect()
      return false
    }),
    filter(() => false),
  )
}

const socketEpic$ = () => socketAction$

export const epics = combineEpics(socketRegisterEpic$, socketEpic$, socketConnectEpic, socketDisconnectEpic)
